import React, {useState, useRef} from 'react'
import ManageBeneficiary from '../../components/Beneficiary/ManageBeneficiary'
import {useSelector} from 'react-redux'
import {Tab, Tabs} from "react-bootstrap";
import ManageDisbursmentHeader from "../../components/Disbursment/ManageDisbursmentHeader";
import SubHeader from '../../components/Subheader/Subheader';


const BeneficiariesMgt = () => {
    const {authData, financialYears} = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem("globalDateId"));
    const [key, setKey] = useState('list');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');


    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setToSearchStr(searchStr);
    };

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    return (
        <div className='fund_list'>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-3'>
                    <ManageBeneficiary listType={key} fromDate={fromDate} toDate={toDate} searchStr={searchStr}/>
            </div>
        </div>
    )
}

export default BeneficiariesMgt
